import { BaseProfileSchema } from '@padspin/firestore-profile';
import * as zod from 'zod';
import {
  DateTimestampToDateAngularSchema,
  TimestampDateFieldValueToTimestampFieldValueAngularSchema,
} from '../firestore-interop';

export const ProfileAngularDbSchema = BaseProfileSchema.omit({
  createdAt: true,
}).extend({
  createdAt: TimestampDateFieldValueToTimestampFieldValueAngularSchema.default(
    new Date(),
  ),
});

export type ProfileAngularDbModel = zod.infer<typeof ProfileAngularDbSchema>;

export const ProfilePartialAngularDbSchema = ProfileAngularDbSchema.partial();

export type ProfilePartialAngularDbModel = zod.infer<
  typeof ProfilePartialAngularDbSchema
>;

export const ProfileAngularAppSchema = BaseProfileSchema.omit({
  createdAt: true,
}).extend({
  createdAt: DateTimestampToDateAngularSchema.default(new Date()),
});

export type ProfileAngularAppModel = zod.infer<typeof ProfileAngularAppSchema>;

export const ProfilePartialAngularAppSchema = ProfileAngularAppSchema.partial();

export type ProfilePartialAngularAppModel = zod.infer<
  typeof ProfilePartialAngularAppSchema
>;
